/**
 * HHT1 TimeLine Contents 정보
 * @type {string[]}
 */

export const HHT1_EP4_ANSWERS = [
    'Tony walks into the living room wearing a pickle costume.',
    'Howard and Bethany pretend that they can’t see Tony.',
    'When Tony asks about his costume, Bethany tells him that it is bright green.',
    'Howard asks Tony why he is a pickle.',
    'Tony says he is the main character for the school play.',
    'The pickle is the star!',
    'Tony says the play is about a pickle that doesn’t want to be sliced.',
    'Then, Howard has an idea.',
    'He says, “I spy with my little eye something that is… green!”',
    'Bethany guesses that it is Tony in the green pickle costume.',
    'Howard pretends that he can’t see Tony again, and starts to laugh with Bethany.',
    'On stage, a big knife is chasing a big pickle which is Tony.',
    'Tony runs toward a salad box with other kids dressed as vegetables.',
    'Tony jumps into the box and crashes into everyone.',
    'Tony ruined the play!',
];

// export const HHT1_EP4_ANSWER_SOUNDS = [
//     '/1_EP04_SB_TL_01.mp3',
//     '/1_EP04_SB_TL_02.mp3',
//     '/1_EP04_SB_TL_03.mp3',
//     '/1_EP04_SB_TL_04.mp3',
//     '/1_EP04_SB_TL_05.mp3',
//     '/1_EP04_SB_TL_06.mp3',
//     '/1_EP04_SB_TL_07.mp3',
//     '/1_EP04_SB_TL_08.mp3',
//     '/1_EP04_SB_TL_09.mp3',
//     '/1_EP04_SB_TL_10.mp3',
//     '/1_EP04_SB_TL_11.mp3',
//     '/1_EP04_SB_TL_12.mp3',
//     '/1_EP04_SB_TL_13.mp3',
//     '/1_EP04_SB_TL_14.mp3',
//     '/1_EP04_SB_TL_15.mp3',
//     '/1_EP04_SB_TL_16.mp3',
//     '/1_EP04_SB_TL_17.mp3',
// ];

export const HHT1_EP4_ANSWER_SOUNDS = [
    '/39a01f2f74c7d03f77ac48bd2e47ac02.mp3',
    '/73547f6f9c64948205f48cb9d2eea4e5.mp3',
    '/65784f2543d13110b36361263244fc4d.mp3',
    '/e624c7a1a60275d6dda6da12f078801f.mp3',
    '/2338fd4fd1395f4cdea1b237b92543c4.mp3',
    '/4a3701a09c9253e2a28aaacb83195cdc.mp3',
    '/74458704694108cbf121f5c3962b9c40.mp3',
    '/0700f6e363946dbbed851648332d2b6d.mp3',
    '/574f6f3ea222e801c3a9b78dbeb4b5e5.mp3',
    '/3a0587ef66560ee45930782b70b53be5.mp3',
    '/7cb9844dde15fd6d5daa114797f2fa43.mp3',
    '/018d271df43a05570c3e06111a2a1a65.mp3',
    '/e0800e97a9d225a4c8ee8fe4319c2fce.mp3',
    '/884bbe8941f93e1f467a25fb14966bdb.mp3',
    '/a2d6c424a278b12fc712fd75696e1ccc.mp3',
    '/ff64ab4ec24e049e970e14d3e2a49fde.mp3',
    '/053eb3eb07267d2d15f47ebc71f4f58c.mp3',

];

export const HHT1_EP4_QUIZ_ITEMS = [{
    'A': HHT1_EP4_ANSWERS[1],
    'B': HHT1_EP4_ANSWERS[14],
    'SoundIndexA': 1,
    'SoundIndexB': 14,
    'answer': HHT1_EP4_ANSWERS[1],
    'sound': [2],
    'exception': false,
},
    {
        'A': HHT1_EP4_ANSWERS[11],
        'B': HHT1_EP4_ANSWERS[3],
        'SoundIndexA': 11,
        'SoundIndexB': 3,
        'answer': HHT1_EP4_ANSWERS[3],
        'sound': [15],
        'exception': false,
    },
    {
        'A': HHT1_EP4_ANSWERS[6],
        'B': HHT1_EP4_ANSWERS[0],
        'SoundIndexA': 6,
        'SoundIndexB': 0,
        'answer': HHT1_EP4_ANSWERS[6],
        'sound': [16, 9],
        'exception': false,
    },
    {
        'A': HHT1_EP4_ANSWERS[2],
        'B': HHT1_EP4_ANSWERS[10],
        'SoundIndexA': 2,
        'SoundIndexB': 10,
        'answer': HHT1_EP4_ANSWERS[10],
        'sound': [11, 12],
        'exception': true,
    },
    {
        'A': HHT1_EP4_ANSWERS[9],
        'B': HHT1_EP4_ANSWERS[13],
        'SoundIndexA': 9,
        'SoundIndexB': 13,
        'answer': HHT1_EP4_ANSWERS[13],
        'sound': [14],
        'exception': false,
    },

]
